<template>
    <span class="content-text" :class="{ 'more-active' : this.checkShowMore, 'target-change' : this.checkTargetChange, 'not-more' : !this.checkReadMoreBtn, 'gray-outed' : this.isGrayOut, 'okrTree': this.okrTree }">
      <p :id="this.checkContentId" ref="contentBox" v-html="formattedString" v-linkified:options="{validate: httpValidation}"></p>
      <span v-show="this.checkReadMoreBtn" @click.stop.prevent="onClickShowMore" class="d-open cursor" :class="{ 'not-show': !this.addMore }">{{this.readMoreText}}</span>
    </span>
</template>
<script>
import linkify from 'vue-linkify'
export default {
  props: {
    // moreStr: {
    //   type: String,
    //   default: 'もっと見る'
    // },
    // lessStr: {
    //   type: String,
    //   default: '閉じる'
    // },
    text: {
      type: String,
      required: true,
      default: ''
    },
    link: {
      type: String,
      default: '#'
    },
    maxChars: {
      type: Number,
      default: 140
    },
    maxCharsSet: {
      // maxCharsだけでいいと思うが、他への影響が怖いので
      type: Boolean,
      default: false
    },
    showMore: {
      type: Boolean,
      dafault: false
    },
    okrTree: {
      type: Boolean,
      dafault: false
    },
    addMore: {
      type: Boolean,
      dafault: false
    },
    contentHeight: {
      type: Number
    },
    targetId: {
      type: String,
      default: 'id'
    },
    detailView: {
      type: Boolean,
      default: true
    },
    replyTo: {
      type: String,
      default: ''
    },
    isGrayOut: {
      type: Boolean,
      default: false
    }
  },
  directives: {
    linkified: linkify
  },
  data: function () {
    return {
      httpValidation: {
        url: function (value) {
          return /^(http)s?:\/\//.test(value)
        }
      },
      readMore: this.isReadMore,
      currentShowMore: this.showMore,
      readMoreBtn: false,
      currentContentHeight: this.contentHeight,
      contentText: '',
      moreStr: this.$t('moreBtnTitle'),
      lessStr: this.$t('restoreBtnTitle'),
      checkTargetChange: false
    }
  },
  watch: {
    formattedString: function () {
      this.checkShowMore = false
    },
    targetId: function () {
      if (this.detailView) {
        console.log('targetId', this.targetId)
        this.checkTargetChange = true
        this.checkTransition()
      }
    }
    // checkContentId: function () {
    //   this.checkShowMore = false
    // }
  },
  updated () {
    let height = this.getClientHeight()
    this.$emit('update-content-height', height)
    this.contentText = this.text
    // this.$nextTick(function () {
    if (this.addMore && !this.detailView) {
      let height = this.getClientHeight()
      this.$emit('update-content-height', height)
    } else if (this.addMore && this.detailView) {
      // console.log('in update true & detail')
      let el = document.querySelector('.sub-column')
      if (el) {
        el.addEventListener('transitionend', this.checkTransition())
      } else {
        let height = this.getClientHeight()
        this.$emit('update-content-height', height)
      }
    }
    // })
  },
  mounted () {
    let height = this.getClientHeight()
    this.$emit('update-content-height', height)
    this.contentText = this.text
    this.$nextTick(function () {
      // this.checkShowMore = false
      if (this.addMore && !this.detailView) {
        let height = this.getClientHeight()
        this.$emit('update-content-height', height)
      } else if (this.addMore && this.detailView) {
        // console.log('in addmore true & detail')
        let el = document.querySelector('.sub-column')
        if (el) {
          el.addEventListener('transitionend', this.checkTransition())
        } else {
          let height = this.getClientHeight()
          this.$emit('update-content-height', height)
        }
      } else {
        let height = this.getClientHeight()
        this.$emit('update-content-height', height)
      }
    })
  },
  computed: {
    checkContentId () {
      return this.targetId
    },
    checkShowMore: {
      get: function () {
        return this.showMore
      },
      set: function (value) {
        this.currentShowMore = value
        this.$emit('update-show-more', this.currentShowMore)
      }
    },
    checkContentHeight () {
      return this.contentHeight
    },
    checkReadMoreBtn () {
      var valContainer = this.text
      let stringArray = []
      if (valContainer) {
        stringArray = valContainer.split(/\r?\n/g)
        if (this.checkContentHeight > 63) {
          return true
        } else if (stringArray.length > 3) {
          return true
        } else {
          return false
        }
      } else {
        return false
      }
    },
    formattedString () {
      var valContainer = this.text
      let stringArray = []
      if (this.maxCharsSet && valContainer.length > this.maxChars) {
        valContainer = valContainer.slice(0, this.maxChars) + '...'
      }
      if (valContainer) {
        let contentText = valContainer.replace(/&/g, '&amp;').replace(/>/g, '&gt;').replace(/</g, '&lt;').replace(/"/g, '&quot;').replace(/'/g, '&#x27;').replace(/`/g, '&#x60;')
        stringArray = contentText.split(/\r?\n/g)
        let resultContent = stringArray.join('<br>')
        if (this.replyTo) { // 返信コメント宛先対応
          let re = new RegExp('^' + this.replyTo.trim())
          resultContent = resultContent.replace(re, '<span class="replyto">' + this.replyTo + '</span>')
        }
        return resultContent
      } else {
        return ''
      }
    },
    readMoreText () {
      if (this.checkShowMore) return this.$t('restoreBtnTitle')
      else return this.$t('moreBtnTitle')
    }
  },
  methods: {
    triggerReadMore (e, b) {
      if (this.link === '#') {
        e.preventDefault()
      }
      if (this.lessStr !== null || this.lessStr !== '') this.checkIsReadMore = b
    },
    onClickShowMore: function () {
      this.checkTargetChange = false
      this.checkShowMore = !this.checkShowMore
    },
    getClientHeight () {
      if (document.getElementById(this.checkContentId)) {
        return document.getElementById(this.checkContentId).scrollHeight
      } else {
        return 0
      }
    },
    checkTransition () {
      // detailViewの開くアニメーションのあとに呼ばれる
      // アニメーション後の要素の高さを取得して、propsで渡す
      const height = this.getClientHeight()
      // console.log('$emit to height:::', height)
      this.$emit('update-content-height', height)
    }
  }
}
</script>
<style scoped>
  .more-active {
    overflow: hidden;
  }
  .more-active p {
    width: 100%;
    overflow-y: auto;
    overflow-x: hidden;
    height: auto !important;
    max-height: 50vh !important;
  }
  .more-active p:before, .more-active p:after {
    display: none;
  }
  .not-more p:before, .not-more p:after {
    display: none;
  }
  .gray-outed {
    color: gray;
  }
  .not-show {
    display: none;
  }
  .target-change p {
    transition: none;
  }
  .okrTree {
    padding-top: 5px;
    text-align: center;
  }
</style>



// WEBPACK FOOTER //
// src/components/ReadMore/ReadMoreComponent.vue